// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddAITicketModal_modalOverlay__7Ylar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  animation: AddAITicketModal_fadeIn__ilLjt 0.05s ease-out forwards;
}

.AddAITicketModal_modalContent__xjiSO {
  background: rgba(24, 26, 27, 0.95);
  backdrop-filter: blur(15px);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 90%;
  max-width: 600px;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: white;
  opacity: 0;
  transform: scale(0.9);
  animation: AddAITicketModal_modalContentFadeIn__hniXF 0.1s ease-out 0.025s forwards;
}

.AddAITicketModal_modalHeader__Gb5SP {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(30, 30, 30, 0.7);
}

.AddAITicketModal_modalHeader__Gb5SP h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #4a9eff;
  font-weight: bold;
}

.AddAITicketModal_closeButton__fmeZb {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #ccc;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.AddAITicketModal_closeButton__fmeZb:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.AddAITicketModal_modalBody__3V4k9 {
  flex: 1 1;
  padding: 1.5rem;
  overflow-y: auto;
  /* Custom scrollbar */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

.AddAITicketModal_modalBody__3V4k9::-webkit-scrollbar {
  width: 6px;
}

.AddAITicketModal_modalBody__3V4k9::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.AddAITicketModal_modalBody__3V4k9::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.AddAITicketModal_modalBody__3V4k9::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

.AddAITicketModal_contentInput__3ylM3 {
  width: 100%;
  background: rgba(40, 40, 40, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 12px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  min-height: 200px;
  box-sizing: border-box;
  color: white;
  transition: border-color 0.2s;
}

.AddAITicketModal_contentInput__3ylM3:focus {
  outline: none;
  border-color: #4a9eff;
  background: rgba(40, 40, 40, 0.9);
}

.AddAITicketModal_contentInput__3ylM3:disabled {
  background-color: rgba(30, 30, 30, 0.5);
  cursor: not-allowed;
  color: rgba(255, 255, 255, 0.5);
}

.AddAITicketModal_contentInput__3ylM3::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.AddAITicketModal_modalFooter__IDsbu {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(30, 30, 30, 0.7);
}

.AddAITicketModal_cancelButton__cu9DW {
  background: rgba(108, 117, 125, 0.8);
  border: none;
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
  min-width: 120px;
}

.AddAITicketModal_cancelButton__cu9DW:hover:not(:disabled) {
  background: rgba(108, 117, 125, 1);
  transform: translateY(-1px);
}

.AddAITicketModal_createButton__ZLnsk {
  background: #4a9eff;
  border: none;
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
  min-width: 120px;
}

.AddAITicketModal_createButton__ZLnsk:hover:not(:disabled) {
  background: #3a8aff;
  transform: translateY(-1px);
}

.AddAITicketModal_createButton__ZLnsk:disabled,
.AddAITicketModal_cancelButton__cu9DW:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

@keyframes AddAITicketModal_fadeIn__ilLjt {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes AddAITicketModal_modalContentFadeIn__hniXF {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (max-width: 768px) {
  .AddAITicketModal_modalContent__xjiSO {
    width: 95%;
    max-height: 90vh;
  }
  
  .AddAITicketModal_modalHeader__Gb5SP,
  .AddAITicketModal_modalBody__3V4k9,
  .AddAITicketModal_modalFooter__IDsbu {
    padding: 1rem;
  }
  
  .AddAITicketModal_contentInput__3ylM3 {
    min-height: 150px;
  }
  
  .AddAITicketModal_cancelButton__cu9DW,
  .AddAITicketModal_createButton__ZLnsk {
    width: 100%;
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AddAITicketModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,iEAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;EACzC,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,mFAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  opacity: 0;\n  animation: fadeIn 0.05s ease-out forwards;\n}\n\n.modalContent {\n  background: rgba(24, 26, 27, 0.95);\n  backdrop-filter: blur(15px);\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  width: 90%;\n  max-width: 600px;\n  max-height: 85vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  color: white;\n  opacity: 0;\n  transform: scale(0.9);\n  animation: modalContentFadeIn 0.1s ease-out 0.025s forwards;\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(30, 30, 30, 0.7);\n}\n\n.modalHeader h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #4a9eff;\n  font-weight: bold;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #ccc;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s;\n}\n\n.closeButton:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.modalBody {\n  flex: 1;\n  padding: 1.5rem;\n  overflow-y: auto;\n  /* Custom scrollbar */\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\n}\n\n.modalBody::-webkit-scrollbar {\n  width: 6px;\n}\n\n.modalBody::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n}\n\n.modalBody::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 3px;\n}\n\n.modalBody::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.contentInput {\n  width: 100%;\n  background: rgba(40, 40, 40, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  padding: 12px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 200px;\n  box-sizing: border-box;\n  color: white;\n  transition: border-color 0.2s;\n}\n\n.contentInput:focus {\n  outline: none;\n  border-color: #4a9eff;\n  background: rgba(40, 40, 40, 0.9);\n}\n\n.contentInput:disabled {\n  background-color: rgba(30, 30, 30, 0.5);\n  cursor: not-allowed;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.contentInput::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 1.5rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(30, 30, 30, 0.7);\n}\n\n.cancelButton {\n  background: rgba(108, 117, 125, 0.8);\n  border: none;\n  color: white;\n  padding: 0.75rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.2s;\n  min-width: 120px;\n}\n\n.cancelButton:hover:not(:disabled) {\n  background: rgba(108, 117, 125, 1);\n  transform: translateY(-1px);\n}\n\n.createButton {\n  background: #4a9eff;\n  border: none;\n  color: white;\n  padding: 0.75rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.2s;\n  min-width: 120px;\n}\n\n.createButton:hover:not(:disabled) {\n  background: #3a8aff;\n  transform: translateY(-1px);\n}\n\n.createButton:disabled,\n.cancelButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes modalContentFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@media (max-width: 768px) {\n  .modalContent {\n    width: 95%;\n    max-height: 90vh;\n  }\n  \n  .modalHeader,\n  .modalBody,\n  .modalFooter {\n    padding: 1rem;\n  }\n  \n  .contentInput {\n    min-height: 150px;\n  }\n  \n  .cancelButton,\n  .createButton {\n    width: 100%;\n    padding: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `AddAITicketModal_modalOverlay__7Ylar`,
	"fadeIn": `AddAITicketModal_fadeIn__ilLjt`,
	"modalContent": `AddAITicketModal_modalContent__xjiSO`,
	"modalContentFadeIn": `AddAITicketModal_modalContentFadeIn__hniXF`,
	"modalHeader": `AddAITicketModal_modalHeader__Gb5SP`,
	"closeButton": `AddAITicketModal_closeButton__fmeZb`,
	"modalBody": `AddAITicketModal_modalBody__3V4k9`,
	"contentInput": `AddAITicketModal_contentInput__3ylM3`,
	"modalFooter": `AddAITicketModal_modalFooter__IDsbu`,
	"cancelButton": `AddAITicketModal_cancelButton__cu9DW`,
	"createButton": `AddAITicketModal_createButton__ZLnsk`
};
export default ___CSS_LOADER_EXPORT___;
